import { useEffect, useMemo, useRef, useState } from "react"

const RARE_SUGGESTION_RATE = 1 / 100

export function useRareSuggestion<T>(
  suggestions: readonly T[],
  rareSuggestion: T,
): readonly T[] {
  const hasRolledRef = useRef(false)
  const [showRareSuggestion, setShowRareSuggestion] = useState(false)

  useEffect(() => {
    if (hasRolledRef.current) {
      return
    }
    hasRolledRef.current = true
    setShowRareSuggestion(Math.random() < RARE_SUGGESTION_RATE)
  }, [])

  return useMemo(() => {
    if (!showRareSuggestion || suggestions.length === 0) {
      return suggestions
    }
    return [...suggestions.slice(0, -1), rareSuggestion]
  }, [rareSuggestion, showRareSuggestion, suggestions])
}
